import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BrandShapeIconColor, BrandShapeIconShape } from '@UI/Brand/BrandShapeIcon'
import type { StrapiIconhubValue } from '@ts-strapi/interfaces'
import type { BlockHomepageTitleProps } from '@ts-blocks/block-homepage-title/interfaces'

interface HomepageTitleWord {
  key: string
  type: 'text'
  text: string
}

interface HomepageTitleMark {
  key: string
  type: 'icon'
  icon: StrapiIconhubValue | null
  shape: BrandShapeIconShape
  color: BrandShapeIconColor
}

export type HomepageTitleItemView = HomepageTitleWord | HomepageTitleMark

export type HomepageTitleDesktopSize = 'display-xl' | 'display-l'

interface BlockHomepageTitleHookOptions {
  block: () => BlockHomepageTitleProps
  desktopSize: () => HomepageTitleDesktopSize
}

interface BlockHomepageTitleHookReturn {
  refItems: ComputedRef<HomepageTitleItemView[]>
  refRootClass: ComputedRef<string>
}

export const useBlockHomepageTitle = ({ block, desktopSize }: BlockHomepageTitleHookOptions): BlockHomepageTitleHookReturn => {
  const refRootClass = computed<string>(() => (
    `block-homepage-title btly-text-heading-l md:btly-text-heading-xl lg:btly-text-${desktopSize()}`
  ))

  const refItems = computed<HomepageTitleItemView[]>(() => (
    (block().items ?? []).map((item, index) => {
      const key = `${item.id ?? index}`
      const shapeIcon = item.shapeIcon
      if (shapeIcon) {
        return {
          key,
          type: 'icon',
          icon: shapeIcon.icon ?? null,
          shape: shapeIcon.shape ?? 'square',
          color: shapeIcon.color ?? 'ultraviolet',
        }
      }
      return {
        key,
        type: 'text',
        text: `${item.text ?? ''} `,
      }
    })
  ))

  return {
    refItems,
    refRootClass,
  }
}
